import classJoin from '@/utility/helper/classJoin';
import React, { ReactNode } from 'react';

export interface IBaseCard {
  children: ReactNode;
  type?: 'basic' | 'dark';
  className?: string;
}

export const BaseCard: React.FC<IBaseCard> = (props: IBaseCard) => {
  const { children, type, className } = props;

  const cardStyle = type === 'dark'
    ? 'bg-gray-800 text-white rounded-[20px]'
    : 'bg-white text-black rounded-[20px]';

  return (
    <div className={classJoin('p-8', cardStyle, className)}>
      {children}
    </div>
  );
};
